import React from 'react';
import noop from '../utils/noop';
import { useDeviationMatureFilter } from '../utils/hooks/useDeviationMatureFilter';
export var MatureDeviationContext = React.createContext({
    showBlocked: false,
    overrideMatureFilter: noop,
});
MatureDeviationContext.displayName = 'MatureDeviationContext';
export var MatureDeviationContextProvider = function (_a) {
    var children = _a.children, deviation = _a.deviation;
    var matureFilter = useDeviationMatureFilter(deviation);
    return (React.createElement(MatureDeviationContext.Provider, { value: matureFilter }, children));
};
MatureDeviationContextProvider.displayName = 'MatureDeviationContextProvider';
//# sourceMappingURL=MatureDeviationContext.js.map